import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from '../Context/TranslationContext';

const OfficeBearersPage = () => {
  const { isTamil } = useTranslation();

  const translations = {
    sections: {
      patron: { en: "Patron", ta: "காப்பாளர்" },
      officeBearers: { en: "Office Bearers", ta: "அலுவலக பொறுப்பாளர்கள்" }
    }
  };

const hierarchyData = {
  patron: {
    name: "Thiru. RAJMOHAN",
    nameTa: "திரு. ராஜ்மோகன்",
    position: "Hon'ble Minister For School Education",
    positionTa: "மாண்புமிகு பள்ளிக்கல்வித்துறை அமைச்சர்",
    location: "Tamil Nadu",
    locationTa: "தமிழ்நாடு",
    image: "/Images/Bearers/Udhaya.png"
  },
  
  officeBearers: [
    {
      name: "Dr. ANBIL MAHESH POYYAMOLZHI",
      nameTa: "முனைவர். அன்பில் மகேஸ் பொய்யாமொழி",
      position: "STATE PRESIDENT , TAMIL NADU",
      positionTa: "மாநில தலைவர், தமிழ்நாடு",
      image: "/Images/Bearers/mahesh.png"
    },
    {
      name: "Dr. S. KANNAPPAN",
      nameTa: "முனைவர். ச. கண்ணப்பன்",
      position: "STATE CHIEF COMMISSIONER",
      positionTa: "மாநில தலைமை ஆணையர்",
      image: "/Images/Bearers/Arivolis.png"
    },
    {
      name: "Thiru. S.NAGARAJA MURUGAN",
      nameTa: "திரு. எஸ். நாகராஜா முருகன்",
      position: "STATE COMMISSIONER (CUB)",
      positionTa: "மாநில ஆணையர் ",
      image: "/Images/Bearers/NagarajaMurugan.png"
    },
    {
      name: "Thiru. M.PALANISAMY",
      nameTa: "திரு. எம். பழனிசாமி",
      position: "STATE COMMISSIONER(S)",
      positionTa: "மாநில ஆணையர்",
      image: "/Images/Bearers/Palanisamy.png"
    },
    {
      name: "Thiru. N.MUTHU KRISHNAN",
      nameTa: "திரு. என். முத்துக்கிருஷ்ணன்",
      position: "STATE COMMISSIONER (AR-S)",
      positionTa: "மாநில ஆணையர் (AR-S)",
      image: "/Images/Bearers/MuthuKrishnan.png"
    },
    {
      name: "Tmt. A.GNANA GOWRI",
      nameTa: "திருமதி. அ. ஞானகௌரி",
      position: "STATE COMMISSIONER (BULBUL)",
      positionTa: "மாநில ஆணையர் (புல்புல்)",
      image: "/Images/Bearers/GnanaGowri.png"
    },
    {
      name: "Tmt. C.AMUTHAVALLI",
      nameTa: "திருமதி. சி. அமுதவல்லி",
      position: "STATE COMMISSIONER (RA)",
      positionTa: "மாநில ஆணையர் ",
      image: "/Images/Bearers/AmuthaValli.png"
    },
    {
      name: "Dr. K.ALAMELU",
      nameTa: "முனைவர். கே. அலமேலு",
      position: "STATE COMMISSIONER (AR-G)",
      positionTa: "மாநில ஆணையர் (AR-G)",
      image: "/Images/Bearers/Alamelu.png"
    },
    {
      name: "Dr. P.A.NARESH",
      nameTa: "முனைவர். பி.ஏ. நரேஷ்",
      position: "STATE SECRETARY",
      positionTa: "மாநிலச் செயலர்",
      image: "/Images/Bearers/Naresh.png"
    },
    {
      name: "Dr. N.VIJAYAN",
      nameTa: "முனைவர். என். விஜயன்",
      position: "STATE TREASURER",
      positionTa: "மாநில பொருளாளர்",
      image: "/Images/Bearers/Vijayan.png"
    },
    {
      name: "Thiru. MUTHAMIZH PANDIAN",
      nameTa: "திரு. முத்தமிழ் பாண்டியன்",
      position: "ASSISTANT STATE SECRETARY",
      positionTa: "மாநில துணைச் செயலாளர்",
      image: "/Images/Bearers/Pandian.png"
    },
    {
      name: "Thiru. J.SAKTHIVEL",
      nameTa: "திரு. ஜே. சக்திவேல்",
      position: "STATE ORGANISING COMMISSIONER(S)",
      positionTa: "மாநில அமைப்பு ஆணையர்",
      image: "/Images/Bearers/Sakthivel.png"
    },
    {
      name: "Selvi. K.GOMATHI",
      nameTa: "செல்வி. கே. கோமதி",
      position: "STATE ORGANISING COMMISSIONER (G)",
      positionTa: "மாநில அமைப்பு ஆணையர்",
      image: "/Images/Bearers/Gomathi.png"
    },
    {
      name: "Thiru. S.NAGARAJAN",
      nameTa: "திரு. எஸ். நாகராஜன்",
      position: "STATE TRAINING COMMISSIONER(S)",
      positionTa: "மாநில பயிற்சி ஆணையர்",
      image: "/Images/Bearers/Nagarajan.png"
    },
    {
      name: "Tmt. M.TENEMOJY",
      nameTa: "திருமதி. எம். டெனிமோஜி",
      position: "STATE TRAINING COMMISSIONER (G)",
      positionTa: "மாநில பயிற்சி ஆணையர் ",
      image: "/Images/Bearers/Tenemojy.png"
    }
  ]
};

  const MemberCard = ({ data, type = "regular" }) => (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className="flex flex-col items-center text-center"
    >
      <div className="relative w-40 h-40 mb-3">
        <div className="absolute inset-0 rounded-full border-4 border-green-500" />
        <div className="w-full h-full rounded-full overflow-hidden">
          <img
            src={data.image}
            alt={isTamil ? data.nameTa : data.name}
            className="w-full h-full object-contain"
          />
        </div>
      </div>
      <div className="space-y-1">
        <h3 className="font-bold text-blue-900">
          {isTamil ? data.nameTa : data.name}
        </h3>
        <p className="text-sm text-gray-700">
          {isTamil ? data.positionTa : data.position}
        </p>
        {data.location && (
          <p className="text-sm text-gray-600">
            {isTamil ? data.locationTa : data.location}
          </p>
        )}
      </div>
    </motion.div>
  );

  const SectionHeader = ({ title, titleTa }) => (
    <div className="bg-blue-900 text-white py-2 px-4 text-center font-semibold mb-6">
      <h2 className="text-lg">
        {isTamil ? titleTa : title}
      </h2>
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50 py-8 pt-36">
      <div className="max-w-6xl mx-auto px-4">
        {/* Patron */}
        <div className="mb-12">
          <div className="flex justify-center">
            <div className="w-full max-w-xs">
              <SectionHeader
                title={translations.sections.patron.en}
                titleTa={translations.sections.patron.ta}
              />
              <MemberCard data={hierarchyData.patron} type="patron" />
            </div>
          </div>
        </div>

        {/* Office Bearers Section */}
        <div className="mb-12">
          <SectionHeader 
            title={translations.sections.officeBearers.en}
            titleTa={translations.sections.officeBearers.ta}
          />
          
          {/* Centered top two members */}
          <div className="flex flex-col items-center space-y-8 mb-12">
            <MemberCard data={hierarchyData.officeBearers[0]} />
            <MemberCard data={hierarchyData.officeBearers[1]} />
          </div>

          {/* Rest of the members in grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-8">
            {hierarchyData.officeBearers.slice(2).map((bearer, index) => (
              <MemberCard key={index} data={bearer} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfficeBearersPage;